/**
 * Default Viraly brand assets, resolved once at build time.
 *
 * Beta builds ship the BETA-ribboned icon set from `public/viraly-beta-icons/`
 * so a beta tab and a production tab are distinguishable at a glance. The gate
 * is Vite's build mode: `VITE_BUILD_MODE=beta` becomes `vite build --mode beta`
 * (see package.json), which makes `import.meta.env.MODE === "beta"`. Same
 * signal the integrations page already uses to gate prod-only behaviour.
 *
 * The beta set is square only - there is no beta wordmark - so every slot
 * renders the square mark on beta, including the wide ones that carry the
 * "viraly" wordmark on production.
 *
 * These are only the DEFAULTS. A white-label tenant's uploaded logos always
 * win; see `useBranding`. The favicon constant must stay in sync with the
 * `<link rel="icon">` block that `vite.config.ts` rewrites for beta builds -
 * that one is the initial paint, this one is what the branding hooks reset to.
 */

export const IS_BETA_BUILD = import.meta.env.MODE === "beta";

const BETA_MARK = "/viraly-beta-icons/viraly-beta-540.png";

/** Wide slot, light theme: expanded sidebar, desktop header, auth pages. */
export const DEFAULT_LOGO_URL = IS_BETA_BUILD
  ? BETA_MARK
  : "/logo/viraly-logo-rect.png";

/** Wide slot, dark theme. */
export const DEFAULT_LOGO_DARK_URL = IS_BETA_BUILD
  ? BETA_MARK
  : "/logo/viraly-logo-white.png";

/** Square slot, light theme: collapsed sidebar, mobile header, dialogs. */
export const DEFAULT_LOGO_ICON_URL = IS_BETA_BUILD
  ? BETA_MARK
  : "/logo/viraly-logo-square-dense.png";

/** Square slot, dark theme. */
export const DEFAULT_LOGO_ICON_DARK_URL = IS_BETA_BUILD
  ? BETA_MARK
  : "/logo/viraly-logo-white-square.png";

/** Browser favicon. */
export const DEFAULT_FAVICON_URL = IS_BETA_BUILD
  ? "/viraly-beta-icons/favicon.ico"
  : "/favicon.ico";
